export default __webpack_public_path__ + "content/media/2.19647301.jpg";